import type { TUntypedTranslator } from "apps/website/types/i18n";

/** Drops key and value typing from a `t` function. See `TUntypedTranslator` for when to use it. */
export const asUntypedTranslator = (t: object): TUntypedTranslator => t as TUntypedTranslator;
